import logodanai from "../../../assets/img/logo-adiwisista.png"
import megaphone from "../../../assets/img/footer/Megaphone.png"
import React, {useEffect, useState} from "react";
import {getDanai} from "../../util/ajax";
import icHotline from "../../../assets/img/footer/phone.svg";
import icEmail from "../../../assets/img/footer/mail.svg";
import icFacebook from "../../../assets/img/footer/facebook.svg";
import icInstagram from "../../../assets/img/footer/instagram.svg";
import icLinkedIn from "../../../assets/img/footer/linkedin.svg";
import icYoutube from "../../../assets/img/footer/youtube.svg";

function Footer() {
    const [content, setContent] = useState('');
    useEffect(() => {
        getDanai(process.env.REACT_APP_MOBILE_API_URL + '/p2p-mobile-api/rest/customerWeb/untuk-diketahui', function (resp) {
            setContent(resp.content);
            console.log(resp);
        }, function () {

        });
    }, []);
    return (
        <footer className="footer">
            <div className="footer-navigation">
                <img className="footer-img"
                     src={logodanai}
                     alt="Danai.id by Adiwisista"/>
                <div className="navigation-text">
                    <div className="section-box">
                        <strong style={{fontSize: '20px'}}>Layanan</strong>
                        <br/><br/>
                        <a href="pinjaman-individu">Pinjaman</a>
                        <br/><br/>
                        <a href="pendanaan">Pendanaan</a>
                        <br/><br/>
                        <a href="perusahaan-mitra">Perusahaan Mitra</a>
                    </div>
                    <div className="section-box">
                        <strong style={{fontSize: '20px', color: "#272727"}}>Informasi
                            Perusahaan</strong>

                        <br/><br/>
                        <a href="tentang-kami">Tentang Kami</a>
                        <br/><br/>
                        <a href="/#informasi-statistik">Informasi Statistik</a>
                        <br/><br/>
                        <a href="media-informasi">Media Informasi</a>
                        <br/><br/>
                        <a href="publikasi-penanganan-pengaduan">Penanganan Pengaduan</a>
                    </div>
                    <div className="section-box">
                        <strong style={{fontSize: '20px', color: "#272727"}}>Pusat Bantuan</strong>

                        <br/><br/>
                        <a href="faq">FAQ</a>
                        <br/><br/>
                        <a href="hubungi-kami">Hubungi Kami</a>
                        <br/><br/>
                        <a href="tnc">Syarat dan Ketentuan</a>
                        <br/><br/>
                        <a href="pernyataan-privasi">Pernyataan Privasi</a>
                        <br/><br/>
                        <a href="whistle-blowing">Whistle Blowing</a>
                    </div>
                    <div className="section-box">
                        <strong style={{fontSize: '20px', color: "#272727"}}>Hubungi Kami</strong>
                        <br/><br/>
                        <div className="flex flex-row gap-1">
                            <img src={icHotline} alt="hotline"/>
                            <a>021 - 5010 3363</a>
                        </div>
                        <br/>
                        <div className="flex flex-row gap-1">
                            <img src={icEmail} alt="email"/>
                            <a href="mailto:customer.care@danai.id">customer.care@danai.id</a>
                        </div>
                        <br/>
                        <strong style={{fontSize: '20px', color: "#272727"}}>Temukan Kami</strong>
                        <br/><br/>
                        <div className="flex flex-row gap-4">
                            <a href="https://www.facebook.com/danai.indonesia" rel="noopener noreferrer"><img
                                src={icFacebook} alt="facebook"/></a>
                            <a href="https://www.instagram.com/danai.id/" rel="noopener noreferrer"><img
                                src={icInstagram} alt="facebook"/></a>
                            <a href="https://www.linkedin.com/company/danai-indonesia/" rel="noopener noreferrer"><img
                                src={icLinkedIn} alt="facebook"/></a>
                            <a href="https://www.youtube.com/channel/UCEq95TmkrBeELAvksHFejVg"
                               rel="noopener noreferrer"><img src={icYoutube} alt="facebook"/></a>
                        </div>
                    </div>
                </div>
            </div>
            <br/><hr/>
            <div className="footer-untuk-diketahui">
                <div className="warning-section">
                    <p>
                        HATI-HATI, TRANSAKSI INI BERISIKO TINGGI. ANDA DAPAT SAJA MENGALAMI KERUGIAN ATAU KEHILANGAN
                        UANG. JANGAN BERUTANG JIKA TIDAK MEMILIKI KEMAMPUAN MEMBAYAR. PERTIMBANGKAN SECARA BIJAK SEBELUM
                        BERTRANSAKSI.
                    </p>
                    <img src={megaphone} alt="megaphone"/>
                </div>
                <div className="ui-g-12 title" style={{color: "#272727"}}>
                    <h4> Untuk Diketahui </h4>
                </div>
                <div className="ui-g-12 body">
                    <article>
                        <div dangerouslySetInnerHTML={{__html: content}}/>
                    </article>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
